import React, { useEffect, useState, useRef, useMemo } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import $ from "jquery";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import toastr from "../../utils/toast";
import { MaterialReactTable } from "material-react-table";
import { openInAppTab } from "../../utils/tabNavigation";

function SearchCandidate({ payload, searchTrigger }) {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const navigate = useNavigate();
  const { setGlobalLoading, token } = useOutletContext();
  const {
    register,
    handleSubmit,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const [keyword, setKeyword] = useState("");
  const [options, setOptions] = useState([]);
  const [functions, setFunctions] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [myroles, setmyroles] = useState([]);
  const [selectedmyroles, setselectedmyroles] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [arr, setArr] = useState(false);
  const keywordRef = useRef(null);
  const [rowSelection, setRowSelection] = useState({});

  const onSubmit = async (data) => {
    console.log("Payload before sending:", data);
    try {
      setGlobalLoading(true);
      const candidates = await axios.post(
        `${API_BASE_URL}/ai_candidates/get_skills_designation_candidates2`,
        {
          functions: data.functions,
          industries: data.industries,
          keywords: data.keywords,
          skills: data.skills,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      console.log("response", candidates);
      if (candidates.status === 200) {
        setOptions(candidates.data.rows);
        if (candidates.data.rows.length <= 0) {
          setOptions([]);
          setArr(true);
          setmyroles([]);
        } else {
          const my_roles = await axios.get(
            `${API_BASE_URL}/common_controller/get_my_roles`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (my_roles.data.options.length > 0) {
            setmyroles(my_roles.data.options);
          }
        }
      }
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  const searchCandidatesWithPayload = async () => {
    if (!payload ) return;
    console.log("Sending payload from parent trigger:", {
      keywords: payload.designation || "",
      functions: payload.functions,
      industries: payload.industries,
      skills: keyword || [],
    });

    try {
      setGlobalLoading(true);
      const candidates = await axios.post(
        `${API_BASE_URL}/ai_candidates/get_skills_designation_candidates2`,
        {
          keywords: payload.designation || "",

          functions: payload.functions,
          industries: payload.industries,
          skills: keyword || [],
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (candidates.status === 200) {
        setOptions(candidates.data.rows || []);

        if (candidates.data.rows.length <= 0) {
          setArr(true);
          setmyroles([]);
        } else {
          const my_roles = await axios.get(
            `${API_BASE_URL}/common_controller/get_my_roles`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (my_roles.data.options.length > 0) {
            setmyroles(my_roles.data.options);
          }
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    if (searchTrigger) {
      searchCandidatesWithPayload();
    }
  }, [searchTrigger]); // whenever parent increments trigger, child calls API

  const columns = useMemo(
    () => [
      {
        header: "Full Name",
        accessorFn: (row) =>
          `${row.firstname ?? ""} ${row.lastname ?? ""}`.trim(), // ← fix
        id: "full_name",
        Cell: ({ row }) => (
          <div className="d-flex align-items-center">
            <Link
              to={`/candidates/view/${row.original?.id}`}
              target="_blank"
              className="avatar avatar-md border avatar-rounded"
              onClick={(event) => {
                event.preventDefault();
                openInAppTab(
                  `/candidates/view/${row.original?.id}`,
                );
              }}
            >
              <img
                src={
                  row.original?.userpic
                    ? `${PINE_URL}/files/candidates/picture/${row.original.userpic}`
                    : `${PINE_URL}/files/candidates/picture/no-pic.png`
                }
                className="img-fluid"
                alt="img"
              />
            </Link>
            <div className="ms-2">
              <h6 className="fw-medium fs-12 mbm-12">
                <Link
                  to={`/candidates/view/${row.original?.id}`}
                  target="_blank"
                  onClick={(event) => {
                    event.preventDefault();
                    openInAppTab(
                      `/candidates/view/${row.original?.id}`,
                    );
                  }}
                >
                  {row.original?.firstname} {row.original?.lastname}
                </Link>
              </h6>
            </div>
          </div>
        ),
      },
      { header: "Company", accessorKey: "current_company" },
      { header: "Designation", accessorKey: "designation" },
      {
        header: "Phone",
        accessorKey: "phone",
        Cell: ({ cell }) => cell.getValue() || "-",
      },
      {
        header: "Email",
        accessorKey: "email",
        Cell: ({ cell }) => cell.getValue() || "-",
      },
      { header: "Industry", accessorKey: "industry_master" },
      { header: "Industry Minor", accessorKey: "industry_minor" },
      { header: "M Function", accessorKey: "function_name" },
      { header: "Country", accessorKey: "location" },
    ],
    [],
  );

  const tableData = useMemo(() => {
    return options.map((item) => ({ ...item })); // or however you derive options
  }, [options]);

  useEffect(() => {
    const ids = Object.keys(rowSelection);
    console.log("ids", ids);

    if (ids.length > 0) {
      $("#map_candidates").removeClass("hide");
      setSelectedIds(ids);
    } else {
      $("#map_candidates").addClass("hide");
      setSelectedIds([]);
    }
  }, [rowSelection]);

  useEffect(() => {
    setRowSelection({});
  }, [options]);

  // useEffect(() => {
  //   if (gridRef.current) {
  //     gridRef.current.api.sizeColumnsToFit();
  //   }
  // }, []);

  const debounceRef = useRef(null);

  const handleKeywordChange = (e) => {
    const value = e.target.value;

    clearTimeout(debounceRef.current);

    // Delay API call by 500ms
    debounceRef.current = setTimeout(async () => {
      if (value.trim().length < 1) return;

      try {
        const response = await fetch(
          `${API_BASE_URL}/ai_candidates/get_keyword_options`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ keywords: value }),
          },
        );

        const data = await response.json();

        if (data.keywords.length < 1) {
          setValue("keywords", "");
          if (keywordRef.current) {
            keywordRef.current.value = "";
          }
          setError("keywords", {
            type: "manual",
            message: "No designation found",
          });
        } else {
          clearErrors("keywords");
          setValue("keywords", value);
        }
      } catch (err) {
        console.error("Error fetching keywords:", err);
      }
    }, 500);
  };

  useEffect(() => {
    $('[name="skills"]').select2({
      multiple: true,
      closeOnSelect: false,
      ajax: {
        type: "POST",
        url: `${API_BASE_URL}/ai_candidates/get_skills_options`,
        dataType: "json",
        contentType: "application/json",
        delay: 250, // Delay for better UX
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", `Bearer ${token}`);
        },
        data: function (params) {
          return JSON.stringify({ keywords: params.term }); // ✅ Send JSON payload
        },
        processResults: function (data) {
          if (!data.keywords || data.keywords.length === 0) {
            return {
              results: [],
            };
          }
          return {
            results: data.keywords.map((item, index) => ({
              id: item.value, // ✅ Add prefix to the ID
              value: item.value,
              text: item.label,
            })),
          };
        },
        cache: true,
      },
      placeholder: "Search Skills",
      allowClear: true,
      minimumInputLength: 1,
      tags: false,
      language: {
        noResults: function () {
          return "No keywords found"; // Ensure "No results found" is displayed
        },
      },
      escapeMarkup: function (markup) {
        return markup;
      },
    });

    $("[name='skills']").on("change", function () {
      const selectedValues = $(this).val() || [];
      setValue("skills", selectedValues); // Update form value
      setKeyword(selectedValues);
    });

    return () => {
      $("[name='skills']").off("change"); // Cleanup on unmount
    };
  }, [token, API_BASE_URL, setValue]);

  function initSelect2() {
    $(".select").select2({
      multiple: true,
      closeOnSelect: false,
      placeholder: "Select Options",
      allowClear: true,
    });
  }

  useEffect(() => {
    const $selectMyroles = $("select[name='myroles']");
    $selectMyroles.select2({
      placeholder: "Select the role you are working on",
    });

    $selectMyroles.on("change", function (e) {
      const selectedValues = $(this).val();
      if (selectedValues.length > 0) {
        $("#discard_candidates").removeClass("hide");
        setselectedmyroles(selectedValues);
      } else {
        $("#discard_candidates").addClass("hide");
        setselectedmyroles([]);
      }
      setValue("myroles", selectedValues || []); // update react-hook-form
    });

    return () => {
      $selectMyroles.select2("destroy");
    };
  }, [myroles]);

  const onSubmitmyroles = async (data) => {
    try {
      setGlobalLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/ai_candidates/get_skills_designation_candidates2`,
        {
          keywords: payload.designation || "",

          functions: payload.functions,
          industries: payload.industries,
          skills: data.skills || [],
          myroles: data.myroles,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data.rows.length > 0) {
        setOptions(response.data.rows);
      }
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  const mapCandidates = async () => {
    if (!selectedmyroles || selectedmyroles.length === 0) {
      // Show error, focus the select2, and stop
      const $selectMyroles = $("select[name='myroles']");

      alert("Please select the role you are working on");
      // Focus on the select2 dropdown
      $selectMyroles.select2("open");

      return; // Prevent further processing
    }

    const data = {
      selectedId: selectedIds,
      selectedRole: selectedmyroles,
    };
    console.log(data);
    try {
      setGlobalLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/ai_candidates/map_to_role`,
        {
          data,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data.success == true) {
        setOptions((prevOptions) =>
          prevOptions.filter((item) => !selectedIds.includes(String(item.id))),
        );

        setRowSelection({});
        setSelectedIds([]);

        toastr.success(response.data.message);
      } else {
        toastr.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }

    // Proceed with mapping logic here
  };

  useEffect(() => {
    async function fetchData() {
      setGlobalLoading(true);
      try {
        const [functionRes, IndustryRes] = await Promise.all([
          axios.get(`${API_BASE_URL}/common_controller/get_major_functions`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }),
          axios.get(
            `${API_BASE_URL}/common_controller/get_master_industry_list`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          ),
        ]);

        const funOptions = functionRes.data.options || [];
        const indOptions = IndustryRes.data.options || [];

        setFunctions(funOptions || []);
        setIndustries(indOptions || []);

        setValue("functions", []);
        setValue("industries", []);

        setTimeout(() => {
          initSelect2();
        }, 0);
      } catch (error) {
        console.log(error);
        setGlobalLoading(false);
      } finally {
        setGlobalLoading(false);
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    $("[name='functions']").on("change", function () {
      const selectedValues = $(this).val() || [];
      setValue("functions", selectedValues);
    });

    $("[name='industries']").on("change", function () {
      const selectedValues = $(this).val() || [];
      setValue("industries", selectedValues);
    });

    return () => {
      // Clean up on unmount
      $("[name='functions']").off("change");
      $("[name='industries']").off("change");
    };
  }, []);

  console.log("tableData sample:", tableData[0]);

  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Search Candidates</h2>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              {/* <div className="row">
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">
                      Search By Designation &nbsp;
                      <span className="text-danger">
                        * {errors.keywords && errors.keywords.message}
                      </span>
                    </label>
                    <input
                      type="text"
                      ref={keywordRef}
                      {...register("keywords", {
                        required: "Keyword is Required",
                        onChange: handleKeywordChange,
                      })}
                      style={{
                        width: "100%",
                        borderColor: "#aaaaaa",
                        height: "35px",
                      }}
                      autoComplete="off"
                      className="form-control"
                      placeholder="Enter Designation"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">
                      Major Function &nbsp;
                      <span className="text-danger">
                        {errors.functions && errors.functions.message}
                      </span>
                    </label>
                    <select
                      className="select"
                      style={{ width: "100%" }}
                      {...register("functions", {
                        // required: "Required",
                      })}
                    >
                        <option value="" disabled>
                          Select Function
                        </option>
                      {functions.length > 0 &&
                        functions.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">
                      Major Industry &nbsp;
                      <span className="text-danger">
                        {errors.industries && errors.industries.message}
                      </span>
                    </label>
                    <select
                      className="select"
                      style={{ width: "100%" }}
                      {...register("industries", {
                        // required: "Required",
                      })}
                    >
                      <option value="" disabled>
                          Select Industry
                        </option>
                      {industries.length > 0 &&
                        industries.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div> */}
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">
                      Skills &nbsp;
                      {/* <span className="text-danger">
                        * {errors.skills && errors.skills.message}
                      </span> */}
                    </label>
                    <select
                      style={{ width: "100%" }}
                      {...register("skills", {
                        required: false,
                      })}
                    ></select>
                  </div>
                </div>
              </div>
              {/* <div className="row">
                <div className="col-md-3 text-left">
                  <button type="submit" className="btn btn-primary">
                    Search By Skills
                  </button>{" "}
                  <b>OR,</b>
                </div>
              </div> */}
              {/* <div className="row">
                <div className="col-md-12 setting">
                  <Link
                    className="btn btn-secondary rounded-pill me-2"
                    to="/business_intelligence/UploadJd"
                    style={{ minWidth: "215px" }}
                  >
                    <i className="fa fa-file"></i> Upload Job Description
                  </Link>
                  <Link
                    className="btn btn-info rounded-pill"
                    to="/business_intelligence/SearchRole"
                    style={{ minWidth: "215px" }}
                  >
                    <i className="fa fa-users"></i> Search By Role
                  </Link>
                  <Link
                    className="btn btn-warning rounded-pill"
                    to="/business_intelligence/SearchMapping"
                    style={{ marginLeft: "10px", minWidth: "215px" }}
                  >
                    <i className="fa fa-users"></i> Search for a Mapping
                  </Link>
                </div>
              </div> */}
            </form>
          </div>
        </div>
        {myroles && myroles.length > 0 ? (
          <form onSubmit={handleSubmit(onSubmitmyroles)}>
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <select
                      {...register("myroles")}
                      className="form-select select2"
                      style={{ width: "44.917px" }}
                    >
                      <option value={""}>
                        Select the role you are working on
                      </option>
                      {myroles.map((item, index) => (
                        <option key={index} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-8">
                    <button
                      className="btn btn-info hide fs-10"
                      id="discard_candidates"
                      type="submit"
                    >
                      <i className="fe fe-eye-off"></i> Exclude candidates of
                      workstation
                    </button>
                    <a
                      href="#"
                      className="btn btn-success hide fs-10"
                      id="map_candidates"
                      style={{ marginLeft: "10px" }}
                      onClick={(e) => {
                        e.preventDefault();
                        mapCandidates();
                      }}
                    >
                      <i className="ti ti-checks"></i> Add candidates to
                      workstation
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </form>
        ) : (
          ""
        )}
        <div className="card">
          <div className="card-body">
            <h5 className="mb-3">Search result</h5>
            <div className="row">
              <div className="col-md-12 text-center">
                {options.length > 0 ? (
                  <MaterialReactTable
                    columns={columns}
                    data={tableData}
                    getRowId={(row) => row.id}
                    enableRowSelection
                    enablePagination
                    enableSorting
                    enableColumnFilters
                    onRowSelectionChange={setRowSelection}
                    enableRowVirtualization={false}
                    state={{ rowSelection }}
                    initialState={{
                      pagination: { pageIndex: 0,pageSize: 50 },showColumnFilters: true
                    }}
                  />
                ) : (
                  <>
                    <img
                      width={"16%"}
                      src="..\assets\img\icons\people_search_icon.png"
                    />
                    <p>
                      <b>
                        {arr === true
                          ? "No Candidate found."
                          : "No candidates yet! Start uploading JD for personalised results."}
                      </b>
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

// function debounce(func, delay) {
//   let timer;
//   return (...args) => {
//     clearTimeout(timer);
//     timer = setTimeout(() => func(...args), delay);
//   };
// }

export default SearchCandidate;
